// extracted by mini-css-extract-plugin
export default {"addMoreButton":"nkgoR","remainingFiles":"GmfR3","changeFileIcon":"XhGXF","fileIcon":"EoSvv","fileActionButton":"JjEzc"};